import { GraphResolverBase } from './GraphResolverBase';
import { ComponentFactory, ViewContainerRef } from '@angular/core';
import { ConfigDataService } from '../services/config-data.service';
import { GraphDataService } from '../services/graph-data-service.service';
import { ViewPeriodService } from '../services/view-period.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DynamicLineChartWrapperComponent } from '../shared-components/dynamic/dynamic-line-chart-wrapper/dynamic-line-chart-wrapper.component';
import { GenericLineChartData } from '../objects/chart';
import { PopoverController } from '@ionic/angular';
import { CHART_PRIMARY_COLOR_OPACITY, CHART_PRIMARY_COLOR, LINE_CHART_COLOR_LIST } from '../configs/color';
import { DynamicGraphAdditionalInput } from '../objects/config';
import * as moment from 'moment';
import { isShowGraph } from '../helpers/util';
import { getAdditionalInput } from '../helpers/DynamicGraphHelper';
import { AuthenticationService } from '../services/authentication.service';

export class VehicleByProvinceResolver extends GraphResolverBase {

    public async createComponent(
        componentFactory: ComponentFactory<unknown>,
        additionalInput: string | DynamicGraphAdditionalInput | undefined,
        configDataService: ConfigDataService,
        graphDataService: GraphDataService,
        _popoverController: PopoverController,
        viewPeriodService: ViewPeriodService,
        viewContainerRef: ViewContainerRef,
        subscription: Subscription,
        authenicationService: AuthenticationService
        ) {
        // load data here
        graphDataService.baseGraphData.addDependency(this.dataDependency);
      const useOnSpecificUser = (getAdditionalInput(additionalInput, 'useOnSpecificUser') || false) as boolean;
        const onSpecificOrganization = (getAdditionalInput(additionalInput, 'onSpecificOrganization')) as string;

        const initialLineChartData: GenericLineChartData[] = [{
            points: graphDataService.vehicleByProvinceChartData$.value.total,
            backgroundColor: CHART_PRIMARY_COLOR_OPACITY,
            color: CHART_PRIMARY_COLOR,
            toolTipLabel: viewPeriodService.DAY_LIST.map(day => `${configDataService.DISPLAY_LANGUAGE.VEHICLE_PROVINCE_CLASS.total},${day}`),
        }];
        let colIndex = 0;
        for (const [province, chartData] of Object.entries(graphDataService.vehicleByProvinceChartData$.value).filter(([provinceName, _]) => provinceName !== 'total').sort()) {
            const labelText = configDataService.DISPLAY_LANGUAGE.VEHICLE_PROVINCE_CLASS[province] || province;
            initialLineChartData.push({
                points: chartData,
                color: LINE_CHART_COLOR_LIST[colIndex],
                toolTipLabel: viewPeriodService.DAY_LIST.map(day => `${labelText},${day}`),
                isDash: true
            });
            colIndex = (colIndex + 1) % LINE_CHART_COLOR_LIST.length;
        }
        const chartData$ = new BehaviorSubject<GenericLineChartData[]>(initialLineChartData);

        subscription.add(graphDataService.vehicleByProvinceChartData$.subscribe((vehicleByProvinceData) => {
            const todayDate = moment().startOf(viewPeriodService.viewPeriod.toMomentString());
            // const diffDate = viewPeriodService.selectedDate.diff(todayDate, 'days');
            const lineChartData: GenericLineChartData[] = [{
                points: vehicleByProvinceData.total,
                backgroundColor: CHART_PRIMARY_COLOR_OPACITY,
                color: CHART_PRIMARY_COLOR,
                toolTipLabel: viewPeriodService.DAY_LIST.map(day => `${configDataService.DISPLAY_LANGUAGE.VEHICLE_PROVINCE_CLASS.total},${day}`),
                label: configDataService.DISPLAY_LANGUAGE.VEHICLE_PROVINCE_CLASS.total,
            }];
            colIndex = 0;
            for (const [province, chartData] of Object.entries(graphDataService.vehicleByProvinceChartData$.value).filter(([provinceName, _]) => provinceName !== 'total').sort()) {
                const labelText = configDataService.DISPLAY_LANGUAGE.VEHICLE_PROVINCE_CLASS[province] || province;
                lineChartData.push({
                    points: chartData,
                    color: LINE_CHART_COLOR_LIST[colIndex],
                    toolTipLabel: viewPeriodService.DAY_LIST.map(day => `${labelText},${day}`),
                    isDash: true,
                    label: labelText,
                });
                colIndex = (colIndex + 1) % LINE_CHART_COLOR_LIST.length;
            }
            chartData$.next(lineChartData);
        }));

        const componentRef = viewContainerRef.createComponent(componentFactory);
        const comInstance = componentRef.instance as DynamicLineChartWrapperComponent;
        comInstance.isLock = this.isLock;
        // comInstance.enableTBD = true;
        comInstance.data$ = chartData$;
        comInstance.label$ = viewPeriodService.DAY_LIST$;
        
        comInstance.isShow = isShowGraph(useOnSpecificUser, authenicationService.userProfile, configDataService.SPECTIFIC_UID, onSpecificOrganization);
        // comInstance.selectedLine$ = selectedGraph$;
        comInstance.title = configDataService.DISPLAY_LANGUAGE.VEHICLE_PROVINCE;
        return comInstance;
    }

}
